import { CANVAS_INTERACTION_MODES } from './constants';

export const getCanvasInteractionMode = (editorPreferences = {}) =>
  editorPreferences.canvasInteractionMode === CANVAS_INTERACTION_MODES.PAN
    ? CANVAS_INTERACTION_MODES.PAN
    : CANVAS_INTERACTION_MODES.SELECT;

export const isCanvasPanMode = (editorPreferences = {}) =>
  getCanvasInteractionMode(editorPreferences) === CANVAS_INTERACTION_MODES.PAN;

export const isCanvasSelectMode = (editorPreferences = {}) =>
  !isCanvasPanMode(editorPreferences);

const PAN_SLACK_EPSILON = 0.5;

/** Minimum zoom (same scale as top-bar %) before Pan mode is offered. */
export const MIN_ZOOM_FACTOR_FOR_PAN = 1.1;

/** Matches `CanvasZooming` preview % (`previewToRealImgFactor`). */
export const getCanvasZoomDisplayFactor = ({
  zoom = {},
  originalImage,
  shownImageDimensions = {},
  resize = {},
}) => {
  const factor = zoom.factor ?? 1;
  if (
    originalImage?.width &&
    originalImage?.height &&
    !resize.width &&
    !resize.height &&
    shownImageDimensions.width &&
    shownImageDimensions.height
  ) {
    return Math.min(
      (shownImageDimensions.width * factor) / originalImage.width,
      (shownImageDimensions.height * factor) / originalImage.height,
    );
  }
  return factor;
};

/** True when stage pan offsets can move (zoom not exactly 100% fit). */
export const hasViewportPanSlack = (
  zoom = {},
  canvasWidth = 0,
  canvasHeight = 0,
) => {
  const factor = zoom.factor ?? 1;
  const xRange = Math.abs(canvasWidth * (1 - factor));
  const yRange = Math.abs(canvasHeight * (1 - factor));
  return xRange > PAN_SLACK_EPSILON || yRange > PAN_SLACK_EPSILON;
};

/** Pan toolbar + pan-mode dragging require zoom ≥ 110% and non-zero pan range. */
export const canUsePanMode = ({
  zoom = {},
  canvasWidth = 0,
  canvasHeight = 0,
  originalImage,
  shownImageDimensions,
  resize,
}) => {
  const displayFactor = getCanvasZoomDisplayFactor({
    zoom,
    originalImage,
    shownImageDimensions,
    resize,
  });
  if (displayFactor < MIN_ZOOM_FACTOR_FOR_PAN) {
    return false;
  }
  return hasViewportPanSlack(zoom, canvasWidth, canvasHeight);
};
